var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "newsletterSignUp",
        tabindex: "-1",
        "aria-labelledby": "newsletterSignUpLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h1",
              {
                staticClass: "modal-title fs-5",
                attrs: { id: "newsletterSignUpLabel" },
              },
              [
                _vm._v(
                  "\n                    Hírlevél feliratkozás\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                disabled: _vm.loading,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "form",
              {
                attrs: {
                  action: _vm.url,
                  method: "POST",
                  id: "newsletterSignUpForm",
                },
                on: {
                  submit: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    { attrs: { for: "newsletter_sign_up_first_name" } },
                    [
                      _vm._v(
                        "\n                            Vezetéknév:\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "FNAME",
                      id: "newsletter_sign_up_first_name",
                      readonly: _vm.loading,
                      required: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "label",
                    { attrs: { for: "newsletter_sign_up_last_name" } },
                    [
                      _vm._v(
                        "\n                            Keresztnév:\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "LNAME",
                      id: "newsletter_sign_up_last_name",
                      readonly: _vm.loading,
                      required: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", { attrs: { for: "newsletter_sign_up_email" } }, [
                    _vm._v(
                      "\n                            Email cím:\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      name: "EMAIL",
                      id: "newsletter_sign_up_email",
                      maxlength: "255",
                      readonly: _vm.loading,
                      required: "",
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  disabled: _vm.loading,
                },
              },
              [_vm._v("\n                    Mégse\n                ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit", form: "newsletterSignUpForm" },
              },
              [_vm._v("\n                    Feliratkozom\n                ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }